export const LANGUAGE_NAMES: Record<string, string> = {
    en: 'English',
    nl: 'Nederlands',
}; 